import React from 'react';
import { getProviderContactPhone } from '@kyruus/provider-components';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { ExtendedProvider, Log } from 'Src/types';
import { CtaListItemBase, ListItemButtonProps } from './CtaListItemBase';
import { PhoneNumber } from '../../styles';
import { messages, DefaultCtaListItem, trackListItemClick } from '../../lib';

interface BasePhoneListItemProps {
  provider: ExtendedProvider;
  log: Log;
}
type PhoneListItemProps = BasePhoneListItemProps & WrappedComponentProps;

export const PhoneListItem = injectIntl(
  ({ provider, intl, log }: PhoneListItemProps) => {
    const providerPhone = getProviderContactPhone(provider) ?? '';
    const phoneLabel = intl.formatMessage(messages.phoneTitle);
    const primaryText = (
      <>
        {phoneLabel}
        <PhoneNumber>{providerPhone}</PhoneNumber>
      </>
    );
    const secondaryText =
      intl.formatMessage(messages.phoneSubtitle) === ' '
        ? undefined
        : intl.formatMessage(messages.phoneSubtitle);
    const href = `tel:${providerPhone}`;
    const handleClick = () => {
      trackListItemClick({
        log,
        listItem: DefaultCtaListItem.Phone,
        providerId: provider.id,
        primaryText: phoneLabel,
        secondaryText
      });
    };
    const buttonProps: ListItemButtonProps = {
      component: 'a',
      href,
      role: 'link',
      onClick: handleClick
    };

    return (
      <CtaListItemBase
        buttonProps={buttonProps}
        isExternalLink={false}
        primaryText={primaryText}
        secondaryText={secondaryText}
      />
    );
  }
);
